import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/finance/wechat_qrcode.png'
import _imports_1 from '@/assets/finance/alipay_qrcode.png'


const _withScopeId = n => (_pushScopeId("data-v-30d54c8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base" }
const _hoisted_2 = { class: "money" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "qrcodeWarp" }
const _hoisted_5 = { class: "leftCode" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "rightTips" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  width: "115"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  width: "115"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    title: "企业充值",
    width: "508px",
    footer: null,
    onCancel: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode("充值金额："),
          _createElementVNode("span", null, "￥" + _toDisplayString(_ctx.formatCny(_ctx.payInfo.amount)), 1)
        ]),
        _createElementVNode("div", _hoisted_3, "企业名称：" + _toDisplayString(_ctx.enterpriseName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.payInfo.qrCode,
            width: "145"
          }, null, 8, _hoisted_6),
          (_ctx.payInfo.payType === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode("打开手机支付宝"),
                _hoisted_8,
                _createTextVNode("扫码继续付款")
              ]))
            : _createCommentVNode("", true),
          (_ctx.payInfo.payType === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode("打开手机微信"),
                _hoisted_10,
                _createTextVNode("扫码继续付款")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.payInfo.payType === 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.payInfo.payType === 2)
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}